class APIManager {
  getCancelSource(): AbortController {
    return new AbortController();
  }

  getConfig(auth: boolean, headers = {}, config = {}): any {
    const configHeader: any = {
      headers: {
        'append-auth-header': auth ? 'true' : 'false',
        ...headers,
      },
      ...config,
    };
    return configHeader;
  }

  sendPost(
    url: any | string,
    provider: any,
    postData: any,
    auth = false,
    headers = {},
    config = {}
  ): Promise<any> {
    return provider.post(url, postData, this.getConfig(auth, headers, config));
  }

  sendPatch(
    url: any | string,
    provider: any,
    postData: any,
    auth = false,
    headers = {},
    config = {}
  ): Promise<any> {
    return provider.patch(url, postData, this.getConfig(auth, headers, config));
  }

  sendGet(
    url: any | string,
    provider: any,
    auth = false,
    headers = {},
    config = {}
  ): Promise<any> {
    return provider.get(url, this.getConfig(auth, headers, config));
  }

  sendGetWithBody(
    url: any | string,
    provider: any,
    postData: any,
    auth = false
  ): Promise<any> {
    const config = this.getConfig(auth);
    config.params = postData;
    return provider.get(url, config);
  }

  sendDelete(
    url: any | string,
    provider: any,
    auth = false,
    headers = {},
    config = {}
  ): Promise<any> {
    return provider.delete(url, this.getConfig(auth, headers, config));
  }
}

export default new APIManager();
